import { Injectable, computed, signal } from '@angular/core';

/**
 * Pilote l'affichage d'un spinner global plein écran pour les flux
 * synchrones (navigation, soumissions bloquantes...). Compteur réentrant :
 * plusieurs appelants concurrents peuvent chacun appeler `show()`/`hide()`
 * sans se marcher dessus (le spinner ne disparaît que quand tous ont appelé
 * `hide()`).
 */
@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
  private readonly pendingCount = signal(0);

  readonly isLoading = computed(() => this.pendingCount() > 0);

  show(): void {
    this.pendingCount.update((count) => count + 1);
  }

  hide(): void {
    this.pendingCount.update((count) => Math.max(0, count - 1));
  }
}
